require('angular');
const moment = require('moment');
require('moment-timezone');

angular.module('app').service('util', function(){

    this.getParameterByName = function(name) {
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    this.getCurrentDisplayLang =   function() {
        let currentDisplayLang = angularAppData.currentDisplayLang ? angularAppData.currentDisplayLang : vm.language.id;
        return currentDisplayLang.toUpperCase();
    }

    this.formatTime = function (time) {
        const [hours, minutes, seconds] = time.split(':');

        return `${hours} h ${minutes} min`;
    }

    function calculateCutOffTimeMoment(cutOffTime) {
        if (!cutOffTime) return null;

        let [hours, minutes, seconds] = cutOffTime.split(':').map(Number);
        let cutOffTimeInMilliseconds = hours * 3600000 + minutes * 60000 + seconds * 1000;

        return moment().add(cutOffTimeInMilliseconds, 'milliseconds');
    }

    function calculateAvailabilities(baseAvailabilities, cutOffTimeMoment, reverseCutOffTimeMoment, formatDates) {
        let availabilities = [];

        angular.forEach(baseAvailabilities, function (el) {
            let startDate = moment(el.startDate, 'YYYY-MM-DD HH:mm:ss');
            if ((!cutOffTimeMoment || startDate.isAfter(cutOffTimeMoment)) && (!reverseCutOffTimeMoment || startDate.isBefore(reverseCutOffTimeMoment))) {
                availabilities.push(formatDates ? startDate.format('YYYY-MM-DD') : el);
            }
        });

        return availabilities;
    }

    this.recalculateAvailability = function (baseAvailabilities, cutOffTime = null, reverseCutOffTime = false) {
        let cutOffTimeMoment = calculateCutOffTimeMoment(cutOffTime);
        let reverseCutOffTimeMoment = calculateCutOffTimeMoment(reverseCutOffTime);
        return calculateAvailabilities(baseAvailabilities, cutOffTimeMoment, reverseCutOffTimeMoment, true);
    };

    this.recalculateBookingAvailability = function (baseAvailabilities, cutOffTime = null, reverseCutOffTime = false ) {
        let cutOffTimeMoment = calculateCutOffTimeMoment(cutOffTime);
        let reverseCutOffTimeMoment = calculateCutOffTimeMoment(reverseCutOffTime);
        return calculateAvailabilities(baseAvailabilities, cutOffTimeMoment, reverseCutOffTimeMoment, false);
    };

});